import type { LineDirection } from "@/elements/arrow/types";

export class LinePoint {
    constructor(x: number, y: number, quadraticType: LineDirection = "horizontal") {
        this.x = x;
        this.y = y;
        this.quadraticType = quadraticType;
    }

    x = 0;
    y = 0;
    quadraticType: LineDirection = "horizontal";
}
